import { render } from "./PanelTipsterCampanas.vue?vue&type=template&id=4d463980&scoped=true"
import script from "./PanelTipsterCampanas.vue?vue&type=script&lang=js"
export * from "./PanelTipsterCampanas.vue?vue&type=script&lang=js"

import "./PanelTipsterCampanas.vue?vue&type=style&index=0&id=4d463980&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d463980"]])

export default __exports__